/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ArgumentType,
    ArgumentTypeFromJSON,
    ArgumentTypeFromJSONTyped,
    ArgumentTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface TaskType
 */
export interface TaskType {
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    displayGroup: string;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    inputType: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskType
     */
    abortable: boolean;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TaskType
     */
    argTemplate: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {{ [key: string]: ArgumentType | undefined; }}
     * @memberof TaskType
     */
    readonly argTypes: { [key: string]: ArgumentType | undefined; };
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskType
     */
    requiredArgs: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TaskType
     */
    outputNames: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: ArgumentType | undefined; }}
     * @memberof TaskType
     */
    readonly outputTypes: { [key: string]: ArgumentType | undefined; };
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    parametersEditorComponent: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskType
     */
    superuserOnly: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    iconClass: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskType
     */
    readonly isAvailable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskType
     */
    allowInJobs: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    newSinceVersion: string | null;
}

export function TaskTypeFromJSON(json: any): TaskType {
    return TaskTypeFromJSONTyped(json, false);
}

export function TaskTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'displayName': json['display_name'],
        'displayGroup': json['display_group'],
        'inputType': json['input_type'],
        'abortable': json['abortable'],
        'argTemplate': json['arg_template'],
        'argTypes': (mapValues(json['arg_types'], ArgumentTypeFromJSON)),
        'requiredArgs': json['required_args'],
        'outputNames': json['output_names'],
        'outputTypes': (mapValues(json['output_types'], ArgumentTypeFromJSON)),
        'parametersEditorComponent': json['parameters_editor_component'],
        'superuserOnly': json['superuser_only'],
        'iconClass': json['icon_class'],
        'isAvailable': json['is_available'],
        'allowInJobs': json['allow_in_jobs'],
        'newSinceVersion': json['new_since_version'],
    };
}

export function TaskTypeToJSON(value?: TaskType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'display_name': value.displayName,
        'display_group': value.displayGroup,
        'input_type': value.inputType,
        'abortable': value.abortable,
        'arg_template': value.argTemplate,
        'required_args': value.requiredArgs,
        'output_names': value.outputNames,
        'parameters_editor_component': value.parametersEditorComponent,
        'superuser_only': value.superuserOnly,
        'icon_class': value.iconClass,
        'allow_in_jobs': value.allowInJobs,
        'new_since_version': value.newSinceVersion,
    };
}


